import { ArrowRight } from "lucide-react";
import type React from "react";
import { Link } from "react-router-dom";

interface HeaderProps {
  title: string;
  link?: string;
  onBack?: () => void;
  children?: React.ReactNode;
  iconClasses?: string
}

function HeaderSubPages({ title, link = "/login", onBack, children, iconClasses }: HeaderProps) {
  if (onBack) {
    return (
      <div className="flex items-center gap-2">
        <button onClick={onBack} className="cursor-pointer">
          <ArrowRight className="text-brand-600 w-7 h-full" />
        </button>
        <h2 className="font-bold text-base text-neutral-700">{title}</h2>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Link to={link}>
          <ArrowRight className={`h-full  w-7 ${iconClasses ? iconClasses : "text-brand-600"}`} />
        </Link>
        <h2 className="font-bold text-base text-neutral-700">{title}</h2>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
}

export default HeaderSubPages;